<template>
  <svg version="1.2" preserveAspectRatio="none" viewBox="0 0 24 24">
    <g>
      <path :fill="fill" xmlns:default="http://www.w3.org/2000/svg" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z">
      </path>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      type: String,
      defualt: '#000'
    }
  }
}
</script>